import Vue from "vue";
import VueI18n from "vue-i18n";
import { englishDomain, germanDomain } from "./domains";

import de from "./lang/de.json";
import en from "./lang/en.json";

Vue.use(VueI18n);
//eslint-disable-next-line

let locale;
switch (window.location.origin) {
  case englishDomain:
    locale = "en";
    break;
  case germanDomain:
    locale = "de";
    break;
  default:
    locale = "de";
}

const i18n = new VueI18n({
  locale,
  messages: {
    de,
    en
  }
});

export default i18n;
